import gql from 'graphql-tag'

export const chargerApiKeyCreate = gql`
  mutation chargerApiKeyCreate {
    chargerApiKeyCreate(input: {}) {
      chargerApiKey
    }
  }
`
